import { render, staticRenderFns } from "./EnableTfa.vue?vue&type=template&id=6d37ad04&scoped=true&"
import script from "./EnableTfa.vue?vue&type=script&lang=js&"
export * from "./EnableTfa.vue?vue&type=script&lang=js&"
import style0 from "./EnableTfa.vue?vue&type=style&index=0&id=6d37ad04&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d37ad04",
  null
  
)

export default component.exports